import './account-entries'
import buildDatepicker from '@app/adapters/datepicker'
import formSubmit from '@app/adapters/form-submit'
import './exact_online_account_selector'
import setupFirmCreation from './setup-firm-creation'
import setupLedgers from './setup-ledgers'
import './market'
import './billing_proposal'
import './special-actions'
import './toggle_selector_visibility'
import './firm_default_permanent_categories'
import './sf-billing'
import { mountUpdateLockedTemplateVersions } from '../special-actions/update-locked-template-versions/mount'

setupFirmCreation({ onDomLoad })

setupLedgers({
  buildDatepicker,
  formSubmit,
  onDomLoad,
})

onDomLoad(function ($dom) {
  const doc = $dom[0]
  const container = doc.querySelector(
    '[data-behaviour="update-locked-template-versions"]'
  )
  if (!container) {
    return
  }

  const firmId = container.dataset.firmId || ''
  const loadTemplatesUrl = container.dataset.loadTemplatesUrl || ''
  const loadCompaniesUrl = container.dataset.loadCompaniesUrl || ''
  const formAction = container.dataset.formAction || ''
  const authenticityToken = container.dataset.authenticityToken || ''

  mountUpdateLockedTemplateVersions(container, {
    firmId,
    loadTemplatesUrl,
    loadCompaniesUrl,
    formAction,
    authenticityToken,
  })
})
